<template>
  <view>
    <view class="fill-ele" :style="fillStyleRef" />
    <uni-load-more
      class="load-more"
      :status="status"
      :iconSize="iconSize"
      :showIcon="showIcon"
      :showText="showText"
      :iconType="iconType"
      :color="color"
    />
  </view>
</template>

<script setup lang="ts">
import type { LoadMoreStatus } from '@/types';
import { ref, toRefs, watch } from 'vue';

interface Props {
  status: LoadMoreStatus;
  iconSize?: number;
  showIcon?: boolean;
  showText?: boolean;
  iconType?: string;
  color?: string;
  loadFillHeight?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  iconSize: 18,
  showIcon: true,
  showText: true,
  iconType: 'auto',
  color: '#777777',
  loadFillHeight: false,
});
const { status, iconSize, showIcon, showText, iconType, color, loadFillHeight } = toRefs(props);

const fillStyleRef = ref({ height: `0rpx` });

watch(
  () => loadFillHeight.value,
  (bool) => {
    if (bool) {
      fillStyleRef.value = { height: `28rpx` };
    } else {
      fillStyleRef.value = { height: `0rpx` };
    }
  },
  { immediate: true }
);
</script>

<style scoped lang="scss">
.fill-ele {
  width: 100%;
  height: 0;
}
</style>
